import React from 'react';
import { useTranslation } from 'react-i18next';

function PassportForm() {

    const { t } = useTranslation();

    const [firstName, setFirstName] = React.useState("");
    const [lastName, setLastName] = React.useState("");
    const [passportNumber, setPassportNumber] = React.useState("");
    const [dateOfBirth, setDateOfBirth] = React.useState("");
    const [issueDate, setIssueDate] = React.useState("");
    const [expiryDate, setExpiryDate] = React.useState("");
    const [country, setCountry] = React.useState("");
    const [agree, setAgree] = React.useState(false);
    const [errors, setErrors] = React.useState({});

    function validateForm() {
        const newErrors = {};
        const latinRegex = /^[A-Za-z\s'-]+$/;
        const passportRegex = /^[A-Za-z0-9]+$/;
        const dateRegex = /^\d{4}-\d{2}-\d{2}$/;

        if (!firstName.match(latinRegex)) newErrors.firstName = "First name must contain only Latin letters";
        if (!lastName.match(latinRegex)) newErrors.lastName = "Last name must contain only Latin letters";
        if (!passportNumber.match(passportRegex)) newErrors.passportNumber = "Passport number must contain only Latin letters and digits";
        if (!dateOfBirth.match(dateRegex)) newErrors.dateOfBirth = "Date of birth must be in YYYY-MM-DD format";
        if (!issueDate.match(dateRegex)) newErrors.issueDate = "Issue date must be in YYYY-MM-DD format";
        if (!expiryDate.match(dateRegex)) newErrors.expiryDate = "Expiry date must be in YYYY-MM-DD format";
        if (country === "") newErrors.country = "Country must be selected";
        if (!agree) newErrors.agree = "You must agree to data processing";

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    }

    function handleSubmit(event) {
        event.preventDefault();
        if (!validateForm()) return;

        const dataToSend = { firstName, lastName, passportNumber, dateOfBirth, issueDate, expiryDate, country, agree };

        fetch("https://api.jai.com.kz/api/passport-lead", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(dataToSend)
        })
            .then(response => response.json())
            .then(json => alert("Form submitted successfully"))
            .catch(error => alert("Error submitting form: " + error));
    }

    return (
        <div className="uk-container uk-margin-top">

            <h1 className="uk-heading-small uk-margin-bottom">{t("Passport Information Form")}</h1>

            <form className="uk-form-stacked uk-width-1-2@m" onSubmit={handleSubmit}>

                <div className="uk-margin">
                    <label className="uk-form-label">{t("First Name")}</label>
                    <div className="uk-form-controls">
                        <input className="uk-input" type="text" value={firstName} onChange={e => setFirstName(e.target.value)} required />
                        {errors.firstName && <span className="uk-text-danger">{errors.firstName}</span>}
                    </div>
                </div>

                <div className="uk-margin">
                    <label className="uk-form-label">{t("Last Name")}</label>
                    <div className="uk-form-controls">
                        <input className="uk-input" type="text" value={lastName} onChange={e => setLastName(e.target.value)} required />
                        {errors.lastName && <span className="uk-text-danger">{errors.lastName}</span>}
                    </div>
                </div>

                <div className="uk-margin">
                    <label className="uk-form-label">{t("Passport Number")}</label>
                    <div className="uk-form-controls">
                        <input className="uk-input" type="text" value={passportNumber} onChange={e => setPassportNumber(e.target.value)} required />
                        {errors.passportNumber && <span className="uk-text-danger">{errors.passportNumber}</span>}
                    </div>
                </div>

                <div className="uk-margin">
                    <label className="uk-form-label">{t("Date of Birth")}</label>
                    <div className="uk-form-controls">
                        <input className="uk-input" type="date" value={dateOfBirth} onChange={e => setDateOfBirth(e.target.value)} required />
                        {errors.dateOfBirth && <span className="uk-text-danger">{errors.dateOfBirth}</span>}
                    </div>
                </div>

                <div className="uk-margin">
                    <label className="uk-form-label">{t("Issue Date")}</label>
                    <div className="uk-form-controls">
                        <input className="uk-input" type="date" value={issueDate} onChange={e => setIssueDate(e.target.value)} required />
                        {errors.issueDate && <span className="uk-text-danger">{errors.issueDate}</span>}
                    </div>
                </div>

                <div className="uk-margin">
                    <label className="uk-form-label">{t("Expiry Date")}</label>
                    <div className="uk-form-controls">
                        <input className="uk-input" type="date" value={expiryDate} onChange={e => setExpiryDate(e.target.value)} required />
                        {errors.expiryDate && <span className="uk-text-danger">{errors.expiryDate}</span>}
                    </div>
                </div>

                <div className="uk-margin">
                    <label className="uk-form-label">{t("Country of Origin")}</label>
                    <div className="uk-form-controls">
                        <select className="uk-select" value={country} onChange={e => setCountry(e.target.value)} required>
                            <option value="">Select Country</option>

                            {/* African countries */}
                            <option value="Algeria">Algeria</option>
                            <option value="Angola">Angola</option>
                            <option value="Benin">Benin</option>
                            <option value="Botswana">Botswana</option>
                            <option value="Burkina Faso">Burkina Faso</option>
                            <option value="Burundi">Burundi</option>
                            <option value="Cameroon">Cameroon</option>
                            <option value="Cape Verde">Cape Verde</option>
                            <option value="Central African Republic">Central African Republic</option>
                            <option value="Chad">Chad</option>
                            <option value="Comoros">Comoros</option>
                            <option value="Congo">Congo</option>
                            <option value="Congo (Democratic Republic)">Congo (Democratic Republic)</option>
                            <option value="Djibouti">Djibouti</option>
                            <option value="Egypt">Egypt</option>
                            <option value="Equatorial Guinea">Equatorial Guinea</option>
                            <option value="Eritrea">Eritrea</option>
                            <option value="Eswatini">Eswatini</option>
                            <option value="Ethiopia">Ethiopia</option>
                            <option value="Gabon">Gabon</option>
                            <option value="Gambia">Gambia</option>
                            <option value="Ghana">Ghana</option>
                            <option value="Guinea">Guinea</option>
                            <option value="Guinea-Bissau">Guinea-Bissau</option>
                            <option value="Ivory Coast">Ivory Coast</option>
                            <option value="Kenya">Kenya</option>
                            <option value="Lesotho">Lesotho</option>
                            <option value="Liberia">Liberia</option>
                            <option value="Libya">Libya</option>
                            <option value="Madagascar">Madagascar</option>
                            <option value="Malawi">Malawi</option>
                            <option value="Mali">Mali</option>
                            <option value="Mauritania">Mauritania</option>
                            <option value="Mauritius">Mauritius</option>
                            <option value="Morocco">Morocco</option>
                            <option value="Mozambique">Mozambique</option>
                            <option value="Namibia">Namibia</option>
                            <option value="Niger">Niger</option>
                            <option value="Nigeria">Nigeria</option>
                            <option value="Rwanda">Rwanda</option>
                            <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                            <option value="Senegal">Senegal</option>
                            <option value="Seychelles">Seychelles</option>
                            <option value="Sierra Leone">Sierra Leone</option>
                            <option value="Somalia">Somalia</option>
                            <option value="South Africa">South Africa</option>
                            <option value="South Sudan">South Sudan</option>
                            <option value="Sudan">Sudan</option>
                            <option value="Tanzania">Tanzania</option>
                            <option value="Togo">Togo</option>
                            <option value="Tunisia">Tunisia</option>
                            <option value="Uganda">Uganda</option>
                            <option value="Zambia">Zambia</option>
                            <option value="Zimbabwe">Zimbabwe</option>

                            {/* Middle Eastern countries */}
                            <option value="Bahrain">Bahrain</option>
                            <option value="Iraq">Iraq</option>
                            <option value="Israel">Israel</option>
                            <option value="Jordan">Jordan</option>
                            <option value="Kuwait">Kuwait</option>
                            <option value="Lebanon">Lebanon</option>
                            <option value="Oman">Oman</option>
                            <option value="Palestine">Palestine</option>
                            <option value="Qatar">Qatar</option>
                            <option value="Saudi Arabia">Saudi Arabia</option>
                            <option value="Syria">Syria</option>
                            <option value="United Arab Emirates">United Arab Emirates</option>
                            <option value="Yemen">Yemen</option>

                            {/* CIS countries */}
                            <option value="Armenia">Armenia</option>
                            <option value="Azerbaijan">Azerbaijan</option>
                            <option value="Belarus">Belarus</option>
                            <option value="Kazakhstan">Kazakhstan</option>
                            <option value="Kyrgyzstan">Kyrgyzstan</option>
                            <option value="Moldova">Moldova</option>
                            <option value="Russia">Russia</option>
                            <option value="Tajikistan">Tajikistan</option>
                            <option value="Turkmenistan">Turkmenistan</option>
                            <option value="Uzbekistan">Uzbekistan</option>
                            <option value="Ukraine">Ukraine</option>

                            {/* Asian countries */}
                            <option value="Afghanistan">Afghanistan</option>
                            <option value="Bangladesh">Bangladesh</option>
                            <option value="Bhutan">Bhutan</option>
                            <option value="Brunei">Brunei</option>
                            <option value="Myanmar">Myanmar</option>
                            <option value="Cambodia">Cambodia</option>
                            <option value="China">China</option>
                            <option value="Timor-Leste">Timor-Leste</option>
                            <option value="India">India</option>
                            <option value="Indonesia">Indonesia</option>
                            <option value="Japan">Japan</option>
                            <option value="Laos">Laos</option>
                            <option value="Malaysia">Malaysia</option>
                            <option value="Maldives">Maldives</option>
                            <option value="Nepal">Nepal</option>
                            <option value="North Korea">North Korea</option>
                            <option value="South Korea">South Korea</option>
                            <option value="Philippines">Philippines</option>
                            <option value="Singapore">Singapore</option>
                            <option value="Sri Lanka">Sri Lanka</option>
                            <option value="Thailand">Thailand</option>
                            <option value="Vietnam">Vietnam</option>
                        </select>
                        {errors.country && <span className="uk-text-danger">{errors.country}</span>}
                    </div>

                </div>

                <div className="uk-margin uk-flex uk-flex-middle">
                    <input className="uk-checkbox" type="checkbox" checked={agree} onChange={e => setAgree(e.target.checked)} />
                    <label className="uk-margin-small-left">I agree for data processing</label>
                    {errors.agree && <span className="uk-text-danger uk-margin-left">{errors.agree}</span>}
                </div>

                <div className="uk-margin">
                    <button className="uk-button uk-button-jai" type="submit">Submit</button>
                </div>

            </form>
        </div>
    );
}

export default PassportForm;
